import { defineStore } from 'pinia';
import { ref } from 'vue';

const defaultOptions = {
  timeout: 5000,
  closeOnClick: true,
};

export const useSnackbarStore = defineStore('snackbarStore', () => {
  const showSnackBar = ref(false);
  const snackbarColour = ref('');
  const snackbarText = ref('');
  const timeout = ref(defaultOptions.timeout);
  const closeOnClick = ref(defaultOptions.closeOnClick);

  function showMessage(text, color, options = defaultOptions) {
    snackbarColour.value = color;
    snackbarText.value = text;
    showSnackBar.value = true;

    setOptions(options);
  }

  function showSuccess(text, options = defaultOptions) {
    showMessage(text, 'succes500', options);
  }

  function showError(text, options = defaultOptions) {
    showMessage(text, 'error500', options);
  }

  function showInfo(text, options = defaultOptions) {
    showMessage(text, 'info', options);
  }

  function setOptions(options) {
    timeout.value = options.timeout ?? defaultOptions.timeout;
    closeOnClick.value = options.closeOnClick ?? defaultOptions.closeOnClick;
  }

  return {
    showSnackBar,
    snackbarColour,
    snackbarText,
    timeout,
    closeOnClick,
    showSuccess,
    showError,
    showInfo,
  };
});
